module.exports = __webpack_public_path__ + "static/media/TH.db6d5211.png";